module.exports = __webpack_public_path__ + "img/PEN.0709f8f1.svg";